import { composeStoreInitializer } from '@beef/redux';
import { combineReducers } from 'redux';
import { tariffServices } from '@fttb/common';
import { checkAddressReducer } from "./checkAddress/reducer";
import { checkAddressInlineReducer } from "../components/OrderTariffFormPopup/OrderTariffFormInlinePopup/store/slice";
import { checkAddressOldReducer, orderProgress, userData } from "../components/OrderTariffFormPopup/OrderTariffFormOldPopup/store/reducers";
import deviceReducer from "./blocks/devices/slice";
import { tariffsReducer } from "./blocks/tariffs/reducer";
import { actionBarWithBackCallReducer } from "./actionBarWithBackCall/reducer";
import { floatingPhoneReducer } from "./FloatingPhone/reducer";
import { infoCardsReducer } from "./infoCards/reducer";
import { addressVerificationReducer } from "./blocks/addressVerification/slice";
import { callbackRequestReducer } from "./callbackRequest/slice";
import { checkboxAgreementReducer } from "./CheckboxAgreement/slice";
var initSharedState = {
  breadcrumbs: [],
  callbackRequestData: {},
  pageSettings: {},
  paymentMethods: [],
  selfCallingPopupData: {},
  userData: {}
};
var initContentState = {
  actionBarWithBackCall: {},
  blocks: []
};
var rootReducer = combineReducers({
  content: function content() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initContentState;
    return state;
  },
  modules: combineReducers({
    actionBarWithBackCall: actionBarWithBackCallReducer,
    checkAddress: checkAddressReducer,
    devices: deviceReducer,
    floatingPhone: floatingPhoneReducer,
    infoCards: infoCardsReducer,
    checkboxAgreement: checkboxAgreementReducer,
    tariffs: tariffsReducer,
    addressCheck: addressVerificationReducer,
    callbackRequest: callbackRequestReducer
  }),
  modalsData: combineReducers({
    orderTariffPopup: combineReducers({
      orderProgress: orderProgress,
      tariffServices: tariffServices,
      userData: userData
    }),
    checkAddressInlinePopup: checkAddressInlineReducer,
    checkAddressOldPopup: checkAddressOldReducer
  }),
  shared: function shared() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initSharedState;
    return state;
  }
});
export var initializeStore = composeStoreInitializer(rootReducer);